/* eslint-disable */
import moment from 'moment'
moment.locale('zh-cn')

// 时间过滤器
// 2018-08-28
export function timeToL(time) {
  if (time) {
    return moment(time).format('YYYY-MM-DD')
  } else {
    return ''
  }
}

export function timeToLLL(time) {
  return moment(time).format('YYYY-MM-DD HH:mm:ss')
}
//转iso时间格式
export function timeToIso(time) {
  let timestamp = Date.parse(time)
  return moment(timestamp).format()
}

export function timeToHHMMSSUtils(time) {
  let timeNew = moment(time).format('YYYY-MM-DD HH:mm:ss')
  if (!(timeNew.includes('1970-01-20') || timeNew.includes('1970-01-21'))) {
    return timeNew
  } else {
    return '--'
  }
}

// 防抖
/**
 * 
 * @param {*} func 
 * @param {*} wait 
 * @param {*} immediate 是否立即执行
 */
let timeout = null;
export function debounce(func, wait, immediate) {
  var result;
  return function () {
    var context = this;
    var args = arguments;

    if (timeout) clearTimeout(timeout);
    if (immediate) {
      var callNow = !timeout;
      timeout = setTimeout(function () {
        timeout = null;
      }, wait);
      if (callNow) result = func.apply(context, args);
    } else {
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    }

    return result;
  }
}

// 商品名称
export const computedName = (skuName, sku) => {
  let name = ''
  if (skuName.prefix) name += `[${skuName.prefix}]`
  name += skuName.name
  if (skuName.unit === '份') name += '约'
  name += +sku.specQuality
  name += sku.specUnit
  name += '/' + skuName.unit
  if (sku.comment) name += `(${sku.comment})`
  return name
}


/**
 * 
 * @param {String|Number} oldDate 传入的日期
 * @param {String|Null} fmt 格式：YYYY-MM-DD hh:mm:ss
 */
export function formatDate(oldDate, fmt) {
  let date = new Date()
  if (oldDate || typeof oldDate === 'string' || typeof oldDate === 'number') {
    date = new Date(oldDate)
  }

  const len2 = (num) => {
    return num < 10 ? '0' + num : '' + num
  }

  const obj = {
    YYYY: date.getFullYear(),
    YY: (date.getFullYear() + '').substring(2, 4) * 1,
    MM: len2(date.getMonth() + 1),
    DD: len2(date.getDate()),
    hh: len2(date.getHours()),
    mm: len2(date.getMinutes()),
    ss: len2(date.getSeconds())
  }

  if (fmt) {
    if (/YYYY/.test(fmt)) {
      fmt = fmt.replace('YYYY', obj.YYYY)
    } else {
      fmt = fmt.replace('YY', obj.YY)
    }
    fmt = fmt.replace('MM', obj.MM)
    fmt = fmt.replace('DD', obj.DD)
    fmt = fmt.replace('hh', obj.hh)
    fmt = fmt.replace('hh', obj.hh)
    fmt = fmt.replace('mm', obj.mm)
    fmt = fmt.replace('mm', obj.mm)
    fmt = fmt.replace('ss', obj.ss)
  } else {
    fmt = `${obj.YYYY}-${obj.MM}-${obj.DD}`
  }
  return fmt
}

// 数据组合成queryString形式
export function json2query(json) {
  let str = ''
  for (let attr in json) {
    let value = json[attr]
    if (Object.prototype.toString.call(value).indexOf('Array') > -1) {
      // 数组
      str += `${attr}=${JSON.stringify(value)}&`
    } else {
      str += `${attr}=${value}&`
    }
  }
  return str.substring(0, str.length - 1)
}

// 生成随机序号
export function randomID() {
  return (Math.round(Math.random() * 10000000)).toString(16)
}

// 计算两点距离

export function getDistance(lat1, lng1, lat2, lng2) {
  var radLat1 = lat1 * Math.PI / 180.0;
  var radLat2 = lat2 * Math.PI / 180.0;
  var a = radLat1 - radLat2;
  var b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
  var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
    Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
  s = s * 6378.137;// EARTH_RADIUS;
  s = Math.round(s * 10000) / 10000;
  return s * 1000;
}
export const contentTemplate = {
  wholeTemplate: '<left>下单时间：${下单时间}</left><br><left>预计送达：${预计送达}</left><br><left>订单编号：${订单号}</left><br><b>${平台名}</b><br><qrc>${订单序号)</qrc><left>客户：${客户名}</left><br><left>电话：${客户电话}</left><br><left>地址：${客户地址}</left><br><left>备注：<b>${备注}</b></left><br><left>商品明细：</left><br><left>${商品明细}</left><br><left>共${商品种数}种${商品件数}件商品</left><br><left>${门店名}${门店电话}</left><br></br>',
  clientTemplate: '<left>客户：${客户名}</left><br><left>电话：${客户电话}</left><br><left>地址：${客户地址}</left><br><left>备注：<b>${备注}</b></left><br>',
  qrTemplate: '<qrc>${订单序号)</qrc>',
  timeTemplate: '<left>下单时间：${下单时间}</left><br><left>预计送达：${预计送达}</left><br><left>订单编号：${订单号}</left><br>',
  goodsTemplate: '<left>商品明细：</left><br><left>${商品明细}</left><br><left>共${商品种数}种${商品件数}件商品</left><br>',
  endTemplate: '<left>${门店名}${门店电话}</left><br></br>'
}
export const arrTemplate = [
  { '客户模板': 'clientTemplate', id: 1 },
  { '二维码模板': 'qrTemplate', id: 2 },
  { '订单时间模板': 'timeTemplate', id: 3 },
  { '商品模板': 'goodsTemplate', id: 4 },
  { '店铺信息模板': 'endTemplate', id: 5 },
  { '默认模板': 'wholeTemplate', id: 6 }
]


// 圆形范围转成多变形
export function circularToPolygon(lng, lat, radius, poinCount = 8) {
  // // 声明一个数组，长度为设定的点数
  // let arr = new Array(poinCount)
  // let oneDu = 111319.55
  // for (let i = 0; i < arr.length; i++) {
  //   // 计算每一个即将生成的坐标点在圆上的弧度（以y轴正轴为基准）
  //   let radian = 360 / poinCount * i * Math.PI / 180
  //   // 根据弧度和半径，计算即将生成的点的坐标
  //   let aa = Math.sin(radian) * radius / (oneDu * Math.cos(lat * Math.PI / 180))
  //   let newLng = lng + aa // 将距离转换成经度的计算公式
  //   let bb = Math.cos(radian) * radius / oneDu
  //   let newLat = lat + bb // 将距离转换成纬度的计算公式

  //   arr[i] = [newLng, newLat]
  //   console.log(radian, 'aa', aa, 'newLng', newLng, 'newLat', newLat, 'bb', bb, 'arr[i]', arr[i])
  // }
  // return arr || []

  let center = new AMap.LngLat(lng, lat)
  // 创建一个圆
  let circle = new AMap.Circle({
    center: center,
    radius: radius,
    strokeColor: "#F33",
    strokeOpacity: 1,
    strokeWeight: 3,
    fillColor: "#ee2200",
    fillOpacity: 0.35
  });
  // console.log('circle', circle)

  // 将圆形转换为多边形
  const path = circle.getPath()
  console.log('path', path, 'path', path[0])
  let arr = []
  path.forEach(item => {
    let i = [item.lng, item.lat]
    arr.push(i)
  })
  return arr
}


// WEBPACK FOOTER //
// ./src/utils/index.js